import { getErrorCode, getErrorMessage } from '@/api/errors'
import { extractValidationMessage } from './validationErrors'

const INLINE_FALLBACKS: Record<string, string> = {
  CONNECTOR_UNAUTHORIZED: 'The key was rejected. Check it and try again.',
  CONNECTOR_UNREACHABLE: 'The provider could not be reached. Try again later.',
}

export function describeTokenSaveError(error: unknown): string | null {
  const fallback = INLINE_FALLBACKS[getErrorCode(error) ?? '']
  if (fallback) {
    return getErrorMessage(error) ?? fallback
  }

  // Validation failures arrive as a bare array, so getErrorMessage finds no `message` field.
  return extractValidationMessage(error) ?? getErrorMessage(error) ?? null
}
